import { Avatar, Box, Group, Text, Title } from '@mantine/core';
import { IllustrativeBadge } from '~portal/components/common';
import { roleLine } from '~portal/data/home';
import { serifEyebrow } from './home.css';

export type MastheadProps = {
  firstName: string;
  /** @desc The signed-in user's full name, for the initials tile. */
  fullName: string;
  workspaceName: string;
  /** @desc The workspace name is the fixture company's, not a WorkOS organisation's. */
  workspaceNameIsIllustrative: boolean;
  isAdmin: boolean;
};

/**
 * @desc The welcome masthead (H1, Figma `426:7806`): a 68px initials tile (no photos — client
 * decision), the workspace name as a serif eyebrow, "Welcome back to H2GC, <first name>!" and the
 * role line. The title is the page's `h1` at the theme's page size (Figma draws it nearer 28px;
 * recorded as a deviation).
 */
export function Masthead({
  firstName,
  fullName,
  workspaceName,
  workspaceNameIsIllustrative,
  isAdmin,
}: MastheadProps) {
  return (
    <Group gap="md" wrap="nowrap" align="center" component="header" data-testid="home-masthead">
      <Avatar size={68} radius="lg" name={fullName} color="initials" />
      <Box miw={0}>
        <Group gap="xs" align="center" wrap="wrap">
          <Text className={serifEyebrow}>{workspaceName}</Text>
          {workspaceNameIsIllustrative && <IllustrativeBadge label="Illustrative workspace" />}
        </Group>
        <Title order={1}>Welcome back to H2GC, {firstName}!</Title>
        <Text c="dimmed" mt={4}>
          {roleLine(isAdmin)}
        </Text>
      </Box>
    </Group>
  );
}
